'use client'

import { useEffect, useRef, useState } from 'react'

type MasksState = {
	top: boolean
	bottom: boolean
}

export function useScrollMasks() {
	const scrollableRef = useRef<HTMLDivElement>(null)
	const [masks, setMasks] = useState<MasksState>({ top: false, bottom: false })

	useEffect(() => {
		const scrollable = scrollableRef.current

		if (!scrollable) return

		const firstElement = scrollable.firstElementChild
		const lastElement = scrollable.lastElementChild

		if (!firstElement || !lastElement) return

		const observer = new IntersectionObserver(
			(elements) => {
				for (const element of elements) {
					if (element.target === firstElement) {
						setMasks((prev) => ({ ...prev, top: !element.isIntersecting }))
					} else if (element.target === lastElement) {
						setMasks((prev) => ({ ...prev, bottom: !element.isIntersecting }))
					}
				}
			},
			{ root: scrollable, rootMargin: '0px', threshold: 0 },
		)

		observer.observe(firstElement)
		observer.observe(lastElement)

		return () => observer.disconnect()
	}, [])

	return { scrollableRef, masks }
}
